import { render, staticRenderFns } from "./phoneSettingsIndex.vue?vue&type=template&id=0f3527dc&scoped=true"
import script from "./phoneSettingsIndex.vue?vue&type=script&lang=js"
export * from "./phoneSettingsIndex.vue?vue&type=script&lang=js"
import style0 from "./phoneSettingsIndex.vue?vue&type=style&index=0&id=0f3527dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3527dc",
  null
  
)

export default component.exports